const styles = (theme) => ({
  wrap: {
    // display: 'flex',
    // overflow: 'hidden',
    fontSize: '0.7rem',
    justifyContent: 'space-between',
    // flexWrap: 'wrap',
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    overflowX: "hidden"
  },

  header: {
    width: '100%',
    padding: '8px 24px 8px 24px',
    height: "100px",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
    // marginTop: '8px'
  },
  logo: {
    width: '15%'
  },
  badge: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  green: {
    background: 'green',
  },
  user: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  content: {
    width: '100%',
    display: 'flex',
    overflowY: "auto",
    flex: 1
    //height: 'calc(100vh - 61px)',
    // marginTop: '20px'
  },
  icon: {
    marginRight: '15px'
  },
  section1: {
    // marginBottom: theme.spacing(2),
    width: '260px',
    display: 'flex',
    flexDirection: 'column',
    //justifyContent: 'space-around'
  },
  link: {
    padding: '10px 24px',
    textDecoration: 'none!important',
    cursor: 'pointer',
    '&:hover': {
      color: 'inherit'
    }
  },
  active: {
    background: '#fef3ea',
    borderLeft: '5px solid rgb(245, 134, 52)',
    paddingLeft: '19px'
  },
  section2: {
    // width: '80%',
    background: '#ededed',
    // marginTop: '-20px'
    flex: 1,
    overflowX: 'scroll',
  },
  heading: {
    padding: '15px 0 0 15px',
    fontWeight: 'bold'
  },
  container: {
    margin: '15px',
    //background: 'white',
    //borderRadius: '5px',
    //padding: '15px'
  },

  boxContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '20px',
  },

  "@media (max-width: 1199px)": {
    boxContainer: {
      display: "none",
      flexWrap: "nowrap",
      gap: "10px",
      marginRight: "10px",
    },
    countBox: {
      minWidth: "100px"
    },
    section1: {
      position: "fixed",
      zIndex: 20,
      transition: "300ms all",
      transform: "translateX(-100%)",
      backgroundColor: "white",
      borderRight: "1px solid black"
    },
    sidebarOpen: {
      transform: "translateX(0)",
    },
  },

  countBox: {
    minHeight: '50px',
    width: '150px',
    height: 'auto',
    borderRadius: '5px',
    border: '1px solid rgb(204, 204, 204);',
    // boxShadow: '3px 3px 10px rgb(87 34 0 / 41%)',
    padding: '5px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'space-around',
    // cursor: 'pointer',
    transition: 'transform 0.3s ease-in-out',
    // margin: '10px',
  },

  countBoxValue: {
    margin: '0px',
    fontSize: '15px',
    fontWeight: 'bold',
  },

  countBoxTitle: {
    margin: '0px',
    fontSize: '10px',
  },

  colorPrimary: {
    color: "#28a745",
  },

  colorSecondary: {
    color: "#f58634",
  },

  borderPrimary: {
    border: '1px solid #28a745b0;',
  },

  borderSecondary: {
    border: '1px solid #f58634b0;',
  }

});

export default styles;
